<template>
  <section>
    <div class="content-wrapper">
      <question v-if="display"></question>
      <errors v-if="isVisibleErrorsModal"></errors>

      <div class="content-heading">
        Manage investments
        <small data-localize="dashboard.WELCOME"></small>
      </div>

      <div class="row">
        <spinner v-if="purchasingNote || loading"></spinner>

        <div class="col-lg-12">
          <onboarding-wizard :userStatus="userStatus"></onboarding-wizard>

          <div class="panel panel-default">
            <div class="panel-header">
              <div class="panel-title">Make an investment</div>
            </div>

            <div class="panel-body">
              <div class="row">
                <div class="col-md-3">
                </div>
                <div class="col-md-6">
                  <h4 class="text-center form-title">Purchase Community Investment Note</h4>

                  <form role="form" novalidate>
                    <div class="form-group form-group-element">
                      <label>Enter investment amount</label>

                      <input v-on:change="removeNegative"
                        v-money="money"
                        v-model="investmentAmount"
                        autocomplete="off"
                        name="investmentAmount"
                        id="investmentAmount"
                        :class="{ 'form-control text-right input-md': true, 'form-control-error': isInvestmentAmountInvalid }"
                        v-validate="{required: true}"
                        v-on:blur="validateInvestmentAmount()"
                        required>
                      <span v-if="isInvestmentAmountInvalid" class="error-feedback">{{investmentAmountError}}</span>
                    </div>

                    <div class="form-group form-group-element">
                      <label>Select rate and term</label>

                      <select v-model="interestYearRateSelected" name="account" class="form-control input-lg" required>
                            <option v-for="interest in interestYearRates" :value="interest.id">{{interest.label}}</option>
                        </select>

                      <div class="has-feedback" v-bind:class="{ 'has-error': interestYearRateErrorMessage }">
                        <strong id="helpBlock6" class="help-block">{{ interestYearRateErrorMessage }}</strong>
                      </div>
                    </div>

                    <div class="form-group form-group-element">
                      <label>Select bank account</label>

                      <select v-model="fundingSourceSelected" name="account" class="form-control input-lg" required>
                            <option v-for="account in fundingSources" :value="account.id">{{account.name}}</option>
                        </select>

                      <div class="has-feedback" v-bind:class="{ 'has-error': fundingSourceErrorMessage }">
                        <strong id="helpBlock6" class="help-block">{{ fundingSourceErrorMessage }}</strong>
                      </div>
                    </div>


                    <div class="checkbox c-checkbox check-margin">
                        <label>
                           <input type="checkbox" value="" name="agreeTerms" v-model="dwollaTermsCheck">
                           <span class="fa fa-check"></span>
                           <terms-of-conditions />
                        </label>
                   </div>
                     <div class="has-feedback" v-bind:class="{ 'has-error': prospectusAndDwollaTermsErrorMessage }">
                        <strong id="helpBlock6" class="help-block">{{ prospectusAndDwollaTermsErrorMessage }}</strong>
                      </div>
                  </form>

                  <button type="submit"
                    class="btn btn-default btn-lg"
                    @click="validateAndSubmitInvestment()"
                    v-bind:disabled="isSubmitButtonDisabled()">
                    Submit
                  </button>
                </div>

                <div class="col-md-3">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    mapActions,
    mapGetters,
    mapMutations,
    mapState,
  } from 'vuex';

  import Errors from '@/components/modals/Errors';
  import Question from '@/components/modals/Question';
  import spinner from '@/components/widgets/Spinner';
  import OnboardingWizard from '@/components/OnboardingWizard';
  import TermsOfConditions from '@/components/TermsOfConditions';

  import {
    VMoney,
  } from 'v-money';

  import {
    HIDE_QUESTION_MODAL,
    SHOW_QUESTION_MODAL,
    SET_ERRORS_MODAL_INFO,
    SHOW_ERRORS_MODAL,
  } from '@/store/mutation-types';

  import { formatAmount, formatDecimal } from '@/util';

  import {
    Constants,
  } from '../data/static/constants';

  const mix = {
    methods: {
      formatAmount,
      formatDecimal,
    },
  };

  export default {
    name: 'purchaseNote',
    async beforeMount() {
      const { isRedirected } = await this.checkUserStatus();

      if (isRedirected) {
        return;
      }
      this.hideQuestionModal();
      this.loadYearsRates();
      this.loadFundingSources();
      this.loadInvestmentsValidations();
      this.setActiveAccountIndex();
    },
    components: {
      errors: Errors,
      question: Question,
      spinner,
      'onboarding-wizard': OnboardingWizard,
      TermsOfConditions,
    },
    mixins: [mix],
    computed: {
      ...mapState('app', [
        'activeAccount',
        'activeAccountId',
        'user',
        'investmentsRestrictions',
      ]),
      ...mapState('home', [
        'userStatus',
      ]),
      ...mapState('note', [
        'purchasingNote',
      ]),
      ...mapState('question', [
        'display',
      ]),
      ...mapState('errors', [
        'isVisibleErrorsModal',
      ]),
      ...mapGetters('app', [
        'hasBeenCreatedAccount',
      ]),
    },
    data() {
      return {
        fundingSources: [],
        interestYearRates: [],
        interestYearRateSelected: null,
        fundingSourceSelected: null,
        investmentAmount: null,
        dwollaTermsCheck: false,
        maximumInvestmentAmount: null,
        minimumInvestmentAmount: null,
        investmentAmountError: '',
        interestYearRateErrorMessage: '',
        fundingSourceErrorMessage: '',
        prospectusAndDwollaTermsErrorMessage: '',
        dwollaTermsUrl: Constants.purchaseNote.dwollaTermsUrl,
        prospectusTermUrl: Constants.purchaseNote.prospectusTermUrl,
        loading: false,
        isInvestmentAmountInvalid: false,
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$',
          precision: 2,
        },
      };
    },
    directives: {
      money: VMoney,
    },
    methods: {
      ...mapMutations('errors', {
        showErrorsModal: SHOW_ERRORS_MODAL,
        setErrorsModalInfo: SET_ERRORS_MODAL_INFO,
      }),
      ...mapActions('account', [
        'getAccountFundingSources',
      ]),
      ...mapActions('home', [
        'getUserStatus',
      ]),
      ...mapActions('note', [
        'getInterestYearRates',
        'purchaseNote',
      ]),
      ...mapMutations('question', {
        hideQuestionModal: HIDE_QUESTION_MODAL,
        showQuestionModal: SHOW_QUESTION_MODAL,
      }),
      setActiveAccountIndex() {
        const activeAccount = this.user.accounts.find(ac => ac.id === this.activeAccountId);
        this.activeAccountIndex = this.user.accounts.indexOf(activeAccount);
      },
      loadInvestmentsValidations() {
        this.minimumInvestmentAmount = this.investmentsRestrictions.minimumAmount;
        this.investmentAmountError = `Please invest at least ${formatAmount(parseInt(this.minimumInvestmentAmount, 10))} in order to proceed`;
      },
      loadYearsRates() {
        this.getInterestYearRates().then((interestYearRates) => {
          this.interestYearRates = interestYearRates;
        });
      },
      loadAccountInformation() {
        const account = this.user.accounts[0];
        this.fundingSourceSelected = !account.defaultFundingSourceId ?
        this.fundingSources[0].id : account.defaultFundingSourceId;
      },
      loadFundingSources() {
        this.getAccountFundingSources(this.activeAccountId).then((fundingSources) => {
          this.fundingSources =
            fundingSources.filter(fss => fss.type === 'bank' && fss.status === 'verified');

          this.loadAccountInformation();
        });
      },
      resetValidations() {
        this.investmentAmountError = '';
        this.interestYearRateErrorMessage = '';
        this.fundingSourceErrorMessage = '';
        this.prospectusAndDwollaTermsErrorMessage = '';
      },
      isInvestmentAmountValid() {
        this.validateInvestmentAmount();
        return !this.isInvestmentAmountInvalid;
      },
      validateInvestmentAmount() {
        const investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
        this.isInvestmentAmountInvalid = false;
        this.investmentAmountError = '';

        if (investmentAmountValue === null || investmentAmountValue === '' || typeof investmentAmountValue === 'undefined') {
          if (!this.investmentAmount && this.investmentAmount !== 0) {
            this.investmentAmountError = Constants.purchaseNote.investmentRequiredError;
            this.isInvestmentAmountInvalid = true;
            return;
          }
        }

        const numericAmount = parseFloat(investmentAmountValue);
        const HARDCODED_MAX_AMOUNT = 100000;

        if (numericAmount < this.minimumInvestmentAmount) {
          this.isInvestmentAmountInvalid = true;
          this.investmentAmountError = `Please invest at least ${formatAmount(parseInt(this.minimumInvestmentAmount, 10))} in order to proceed`;
        } else if (numericAmount > HARDCODED_MAX_AMOUNT) {
          this.isInvestmentAmountInvalid = true;
          this.investmentAmountError = 'The maximum per-transaction amount is $100,000.00. If you would like to invest a higher amount, you can make multiple $100,000 or less purchases in a row, and contact us to combine them into one Note.';
        } else {
          this.isInvestmentAmountInvalid = false;
          this.investmentAmountError = '';
        }
      },
      isFormValid() {
        this.resetValidations();

        if (!this.interestYearRateSelected) {
          this.interestYearRateErrorMessage = Constants.purchaseNote.interestYearRateError;
        }

        if (!this.fundingSourceSelected) {
          this.fundingSourceErrorMessage = Constants.purchaseNote.fundingSourceError;
        }

        if (!(this.dwollaTermsCheck)) {
          this.prospectusAndDwollaTermsErrorMessage =
            Constants.purchaseNote.propectusAndDwollaTermsError;
        }

        const isInvestmentAmountValid = this.isInvestmentAmountValid();

        const isValid = this.interestYearRateErrorMessage === '' &&
          this.fundingSourceErrorMessage === '' &&
          isInvestmentAmountValid &&
          this.prospectusAndDwollaTermsErrorMessage === '';

        return isValid;
      },
      methodToExecuteInQuestionModal({
        data,
      }) {
        this.hideQuestionModal();
        this.purchaseNote({
          data,
        })
          .then(() => {
            if (this.$route.query.first) {
              this.$router.push({
                name: 'AccountSummary',
                params: { purchasedNote: true },
              });
            } else {
              this.$router.push({
                name: 'Notes',
                params: { purchasedNote: true },
              });
            }
            window.dataLayer.push({
              event: 'purchaseNote',
              userID: this.user.userId,
            });
          })
          .catch(() => {
            this.setErrorsModalInfo(['Something went wrong. Please try again.']);
            this.showErrorsModal();
          });
      },
      validateAndSubmitInvestment() {
        const isFormValid = this.isFormValid();
        const unformattedValue = this.getUnformattedValue(this.investmentAmount);
        const investmentAmount = parseFloat(unformattedValue.toFixed(2));
        if (isFormValid) {
          const data = {
            fundingSourceId: this.fundingSourceSelected,
            interestYearRateId: this.interestYearRateSelected,
            accountId: this.activeAccountId,
            investmentAmount,
          };

          this.showQuestionModal({
            title: Constants.purchaseNote.modalTitle,
            question: Constants.purchaseNote.modalQuestion,
            method: () => {
              this.methodToExecuteInQuestionModal({
                data,
              });
            },
            yesButtonText: Constants.purchaseNote.modalYesButtonText,
            hideCancelButton: false,
          });
        }
      },
      async checkUserStatus() {
        this.loading = true;
        if (!this.hasBeenCreatedAccount) {
          this.$router.push({ name: 'AccountSummary' });
          return {
            isRedirected: true,
          };
        }

        return this.getUserStatus({
          accountId: this.activeAccount.id,
        }).then(({ status, needs }) => {
          if (status === 'suspended') {
            this.$router.push({ name: 'AccountSuspended' });
            return {
              isRedirected: true,
            };
          } else if (needs.includes('FUNDING_SOURCE')) {
            this.$router.push({ name: 'AddFundingSource' });
            return {
              isRedirected: true,
            };
          }
          this.loading = false;
          return {
            isRedirected: false,
          };
        }).catch(() => {
          this.loading = false;
        });
      },
      isSubmitButtonDisabled() {
        const investmentAmountValue = this.getUnformattedValue(this.investmentAmount);
        const numericAmount = parseFloat(investmentAmountValue);
        const HARDCODED_MAX_AMOUNT = 100000;

        let isInvalidForSubmit = false;
        if (numericAmount < this.minimumInvestmentAmount) {
          isInvalidForSubmit = true;
        } else if (numericAmount > HARDCODED_MAX_AMOUNT) {
          isInvalidForSubmit = true;
        }

        return isInvalidForSubmit ||
          !this.fundingSourceSelected || !this.interestYearRateSelected || !this.dwollaTermsCheck;
      },
      getUnformattedValue(value) {
        const unformattedValue = value ? value.toString().replace('$', '').replace(/,/g, '') : '';
        return this.formatDecimal(unformattedValue);
      },
      removeNegative() {
        if (this.investmentAmount === null) return;
        this.investmentAmount = this.investmentAmount.toString().replace('-', '');
      },
    },
  };
</script>

<style scoped>
  .top-margin {
    margin-top: 3%;
  }

  .left-margin {
    margin-left: 3%;
  }

  .panel-height {
    height: 250px;
  }

  .panel-margin {
    margin: 5% 0;
    width: 100%;
  }

  .message-label {
    font-size: 26px;
    font-weight: 100;
    color: #9bb894;
    font-style: italic;
  }

  .message-icon {
    font-size: 70px;
    color: #A1C7A2;
    display: block;
    margin: 0 35%;
  }

  .form-group {
    display: table;
    margin: 0 auto;
    line-height: 60px;
  }

  .panel-header {
    padding-top: 10px;
  }

  .form-title {
    margin-bottom: 30px;
  }

  .form-group-element {
    width: 100%;
    line-height: 20px;
  }
  .checkbox {
    margin-left: 10px;
  }
  .c-checkbox span,
  .c-radio span {
    margin-left: -28px;
  }
</style>



// WEBPACK FOOTER //
// PurchaseNote.vue?2f497f00